

import CustomerInvoiceAfterPay from "./CustomerInvoiceAfterPay";
import { normalizeOrderForPrint } from "../printNormalizer";

// 📌 **CustomerInvoiceTemplate** - قالب فاتورة العميل

// 📌 **handleBrowserPrintBeforePay** - دالة طباعة الفاتورة عبر المتصفح قبل الدفع
export const handleBrowserPrintAfterPay = async (orderDetails, invoiceData, orderId) => {
  // ✅ استلام بيانات الحسابات كما هي من TableOrderInfo بدون override
  const invoiceDataForPrint = { ...(invoiceData || {}) };
  const normalizedOrder = normalizeOrderForPrint(orderDetails);

  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  // ✅ ابعت بيانات TableOrderInfo مباشرة للقالب
  const html = await CustomerInvoiceAfterPay(normalizedOrder, invoiceDataForPrint, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener &&
      printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
